import request from "../request";

export const getMarking = (curriculumId) =>
  request.get(`curriculum/${curriculumId}/marking`).then((res) => res);

export const createMarking = (curriculumId, data) =>
  request.post(`curriculum/${curriculumId}/marking`, data).then((res) => res);

export const updateMarking = (curriculumId, id, data) =>
  request.put(`curriculum/${curriculumId}/marking/${id}`, data).then((res) => res);

export const deleteMarking = (curriculumId, id) =>
  request.delete(`curriculum/${curriculumId}/marking/${id}`).then((res) => res);
